<template>
    <div class="consultation-header">
        <div class="header-first">
            <div style="text-align:center;font-family: Microsoft YaHei;font-weight: bold;color: #272727;margin-top:15px;font-size:22px"><span>县级医工体</span></div>
        </div>
        <div class="header-second">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>背景</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;"> 	2017年4月 国务院办公厅《国务院办公厅关于推进医疗联合体建设和发展的指导意见》，意见提出：在县域主要组建医疗共同体。重点探索以县级
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">医院为龙头、乡镇卫生院为枢纽、村卫生室为基础的县乡一体化管理，与乡村一体化管理有效衔接。充分发挥县级医院的城乡纽带作用和县域龙头作用，
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">形成县乡村三级医疗卫生机构分工协作机制，构建三级联动的县域医疗服务体系。</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;text-indent:30px;">2019年国家卫生健康委员会和基层卫生健康司发布《关于印发紧密型县域医疗卫生共同体建设试点省和试点县名单的通知》，通知提出：推进医共</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">体内县级医疗机构和基层医疗卫生机构信息系统融合，实现对医疗服务、公共卫生服务、财政管理、人事管理和绩效管理等的技术支撑。依托区域全民健</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">康信息平台，推进医疗卫生信息共享，提升医疗卫生机构协同服务水平和政府监管水平。发展远程医疗服务，以县级医疗机构为纽带，向下辐射有条件的</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">乡镇卫生院和村卫生室，向上与城市三级医院远程医疗系统对接。</div>
            <div style="margin-top:25px;">
                <img src="@/assets/image/xianyi.png" alt="">
            </div>
        </div>
        <div class="header-second" style="margin-top:20px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>方案简介</span></div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;margin-top:20px;text-indent:30px;"> 		围绕医共体的建设目标，平台为县乡村三级医疗机构的服务联动提供支撑。县级医院可以通过网络培训、手术示教、视频会议等方式对基层医生提

        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px">供培训提升。通过远程门诊、远程会诊、远程超声等方式，让基层患者足不出户就可以对接县级甚至市级三甲医院的专家，缓解看病难和看病贵的难题，
        </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">同时也对基层医生帮教。 通过院前急救平台，县级医院可以统筹医共体内急救车资源，提高院前急救的效率和水平，更有效的保障基层民众的生命健康。  </div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;"> 通过该平台支持，患者在基层医院首诊和通过远程门诊、会诊解决日常诊疗问题，碰到疑难问题通过双向转诊直接转入到县级医院进一步治疗，县级医院</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">有问题再通过与三甲医院之间进行会诊和双向转诊。 对于上级医院治疗后进入康复阶段的患者可以转入到基层医院进行治疗，康复期通过远程方式支持基</div>
            <div style="font-family: Microsoft YaHei;font-weight: 400;color: #7D7D7D;padding-top:10px;">层医院完成后续工作，减少上级医院的压力，真正实现上下联动、急慢分治的目标。</div>
            <div style="margin-top:25px;">
                <img src="@/assets/image/xianyi1.png" alt="" style="position: relative;left:9%;">
            </div>
        </div>
        <div class="header-firth" style="margin-top:15px">
            <div style="font-family: Microsoft YaHei;font-weight: bold;color: #4E4E4E;font-size:18px"><span>方案框架</span></div>
            <div style="margin-top:20px">
                <img src="@/assets/image/xianyi2.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss">
    .consultation-header{
        width: 100%;
        padding-left: 20px;
        .header-forth{
            margin-right:70px;
        }

    }
</style>